import { IMaskInput } from 'react-imask'
// import { stripPhoneValue } from '../../../utils/phone'

const PhoneField = ({ formikSetter, ...props }) => {
  const { name } = props

  const handler = (value) => {
    // console.log(value)
    // console.log(stripPhoneValue(value))
    formikSetter(name, value)
  }
  return (
    <IMaskInput
      {...props}
      id={name}
      onAccept={handler}
      mask="+38\0 (00) 000 00 00"
      placeholder="+380"
      unmask={true}
      lazy={false} // make imask placeholder (not regular input placeholder!) always visible
    />
  )
}

export default PhoneField
